import axios from "@/plugins/axios";

let url = "/api/v1/shop/products";

export default {
    getProducts(data){
        return axios.get(url, data).then(result => result.data);
    },
    getProduct(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    }
}
